export default "__VITE_ASSET__BLT8DrBA__"